import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgIconCustomChevronDown({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M19 5.5a.517.517 0 00-.14-.354.457.457 0 00-.67 0L10 13.793 1.808 5.146a.457.457 0 00-.67 0 .52.52 0 000 .707l8.527 9a.457.457 0 00.67 0l8.527-9A.513.513 0 0019 5.5V5.5z"
        fill="currentColor"
        fillRule="nonzero"
        stroke="currentColor"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export default SvgIconCustomChevronDown;
